import { requestJSON } from './http';

const fetchLockedJobs = () =>
  requestJSON('/jobs/locked-jobs');

export default {
  fetchLockedJobs,
};
